<template>
  <div class="wrap">
    <!-- 头部 -->
    <headTop :toggle="4"></headTop>
    <!-- 中间内容 -->
    <div class="specialistContent">
      <div style="padding: 0.2em 3em 0.8em 3em; box-sizing: border-box">
        <!-- 左侧菜单栏 -->
        <div class="box">
          <div class="specialistContent_left">
            <div class="specialistContent_left_title">常用业务</div>
            <div
              class="bG"
              v-for="(item, index) in leftMenu1"
              :key="index"
              :class="{ active: toggle == item.name }"
              @click="changeDetail(item)"
            >
              {{ item.name }}
            </div>
          </div>
          <!-- 右侧内容 -->
          <div class="specialistContent_right">
            <div class="specialistContent_right-inner" v-if="list.length > 0">
              <div class="specialistContent_right_title">
                <div class="title">{{ toggle }}</div>
              </div>
              <div class="rightContent rightInfo" v-if="toggle == '业务流程'">
                <div class="search">
                  <div class="search-wrap">
                    <el-input
                      placeholder="请输入您要搜索的内容"
                      v-model="searchResult"
                    >
                    </el-input>
                    <img
                      class="search-img"
                      src="@/assets/image/index/search.png"
                      alt
                      @click="handleSearch"
                    />
                  </div>
                </div>
                <div class="info-box" v-if="!isAllEmpty && newArray">
                  <div
                    class="info-box-container"
                    v-for="(item, index) in filterList(list[0].children)"
                    :key="index"
                  >
                    <div class="info-box-title">{{ item.comments }}</div>
                    <div
                      class="info-box-content"
                      v-for="(subItem, subIndex) in newArray.filter(
                        (e) => e.paramValue == item.paramValue
                      )"
                      :key="subIndex"
                    >
                      <div v-if="subItem.data.length > 0">
                        <div
                          class="info-box-content-inner"
                          v-for="(thirdItem, thirdIndex) in subItem.data"
                          :key="thirdIndex"
                        >
                          <div class="info-box-content-inner-item">
                            <a
                              :href="
                                thirdItem.fileUrl
                                  ? $store.getters.imgUrl + thirdItem.fileUrl
                                  : thirdItem.linkUrl
                              "
                              target="_blank"
                              class="link-url"
                            >
                              {{ thirdItem.title }}</a
                            >
                          </div>
                        </div>
                        <div class="pagination">
                          <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="
                              handleCurrentChange($event, subItem)
                            "
                            :page-size="limit"
                            layout="prev, pager, next, jumper"
                            :total="subItem.total"
                          >
                          </el-pagination>
                        </div>
                      </div>
                      <div v-else>暂无数据</div>
                    </div>
                  </div>
                </div>
                <div v-else>暂无数据</div>
              </div>

              <div class="rightInfo" v-if="toggle == '资料库'">
                <div class="search">
                  <div class="search-wrap">
                    <el-input
                      placeholder="请输入您要搜索的内容"
                      v-model="searchResult"
                    >
                    </el-input>
                    <img
                      class="search-img"
                      src="@/assets/image/index/search.png"
                      alt
                      @click="handleSearch"
                    />
                  </div>
                </div>
                <div class="info-box" v-if="!isAllEmpty && newArray">
                  <div
                    class="info-box-container"
                    v-for="(item, index) in filterList(list[1].children)"
                    :key="index"
                  >
                    <div class="info-box-title">{{ item.comments }}</div>
                    <div
                      class="info-box-content"
                      v-for="(subItem, subIndex) in newArray.filter(
                        (e) => e.paramValue == item.paramValue
                      )"
                      :key="subIndex"
                    >
                      <div v-if="subItem.data.length > 0">
                        <div
                          class="info-box-content-inner"
                          v-for="(thirdItem, thirdIndex) in subItem.data"
                          :key="thirdIndex"
                        >
                          <div class="info-box-content-inner-item">
                            <a
                              :href="
                                thirdItem.fileUrl
                                  ? $store.getters.imgUrl + thirdItem.fileUrl
                                  : thirdItem.linkUrl
                              "
                              target="_blank"
                              class="link-url"
                            >
                              {{ thirdItem.title }}</a
                            >
                          </div>
                        </div>
                        <div class="pagination">
                          <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="
                              handleCurrentChange($event, subItem)
                            "
                            :page-size="limit"
                            layout="prev, pager, next, jumper"
                            :total="subItem.total"
                          >
                          </el-pagination>
                        </div>
                      </div>
                      <div v-else>暂无数据</div>
                    </div>
                  </div>
                </div>
                <div v-else>暂无数据</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <footCode></footCode>
      </div>
    </div>
  </div>
</template>
<script>
import footCode from "../../components/footCode";
import headTop from "../../components/HeadTop";
import imgBox from "../../components/imgBoxAndDialog";
export default {
  name: "enterpriseDetail",
  components: {
    footCode,
    headTop,
    imgBox,
  },
  data() {
    return {
      leftMenu1: [
        { name: "业务流程", id: 1 },
        { name: "资料库", id: 2 },
      ],
      toggle: "业务流程",
      officeId: "",
      total: "",
      name: "产品与服务",
      mode: {},
      expertList: [],
      imgBoxList: [],
      honorList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      searchResult: "",
      allDetails: "",
      newArray: [],
      currentPage: 1,
      limit: 5,
      list: [],
      isAllEmpty: true,
    };
  },
  computed: {
    filterList() {
      return function (val) {
        let arr = [];
        this.newArray.map((item) => {
          for (let i in val) {
            if (val[i].paramValue == item.paramValue) {
              if (item.data.length > 0) {
                arr.push(val[i]);
              }
            }
          }
        });
        arr.sort((a, b) => {
          return a.sort > b.sort ? 1 : -1;
        });
        return arr;
      };
    },
    // list[1].children.filter((x)=>
    //                 x.paramValue == isShowTitle(x)
    //               )
    isShowTitle() {
      return function (val) {
        this.newArray.map((item) => {
          if (item.paramValue == val.paramValue) {
            if (item.data.length > 0) {
              return item.paramValue;
            } else {
              return item.paramValue;
            }
          }
        });
      };
    },
  },
  beforeRouteLeave(to, from, next) {
    this.toggle = "业务流程";
    next();
  },

  mounted() {
    this.getList();
  },

  methods: {
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    // 分页
    handleCurrentChange(val, item) {
      // console.log(`当前页: ${val}`, item);
      this.ajaxUtil({
        method: "get",
        url:
          this.$store.state.axiosUrl +
          `/api/home/common/business/page?limit=${this.limit}&page=${val}&type2=${item.paramValue}&title=${this.searchResult}`,
      }).then((res) => {
        console.log("change page", res);
        // this.newArray.push({data:res.data,paramValue:item.paramValue,total:res.count});
        this.newArray.map((e, index) => {
          if (e.paramValue == item.paramValue) {
            this.newArray[index].data = res.data;
            this.newArray[index].total = res.count;
          }
          //  console.log("data index",item,index)
        });
      });
    },
    changePagination(current) {
      // 第几页
      this.sendAxios.page = current;
      this.getList();
    },
    changeDetail(item) {
      if (this.toggle != item.name) {
        this.toggle = item.name;
        // console.log("this.toggle", this.toggle);
        this.officeId = item.id;
        this.searchResult = "";
        this.list = [];
        this.newArray = [];
        this.getList();
      }
    },
    // 获取标题
    getList() {
      this.ajaxUtil({
        method: "get",
        url: this.$store.state.axiosUrl + `/api/home/getCommonBusinessTypeTree`,
      }).then((res) => {
        this.list = res.data;
        console.log("获取标题", this.list);
        this.getDetails();
      });
    },
    // 根据标题获取内容
    getDetails(val) {
      if (this.toggle == "业务流程") {
        // console.log("in 1");
        this.list[0].children.map((item) => {
          this.ajaxUtil({
            method: "get",
            url:
              this.$store.state.axiosUrl +
              `/api/home/common/business/page?limit=${this.limit}&page=${this.currentPage}&type2=${item.paramValue}&title=${this.searchResult}`,
          }).then((res) => {
            if (!res.data) {
              this.isAllEmpty = false;
            }
            this.newArray.push({
              data: res.data,
              paramValue: item.paramValue,
              total: res.count,
            });
          });
        });
        console.log(
          "根据标题获取内容",
          "this.list",
          this.list,
          "this.newArray",
          this.newArray
        );
      } else if (this.toggle == "资料库") {
        this.list[1].children.map((item) => {
          this.ajaxUtil({
            method: "get",
            url:
              this.$store.state.axiosUrl +
              `/api/home/common/business/page?limit=${this.limit}&page=${this.currentPage}&type2=${item.paramValue}&title=${this.searchResult}`,
          }).then((res) => {
            this.newArray.push({
              data: res.data,
              paramValue: item.paramValue,
              total: res.count,
            });
          });
        });
        console.log("资料库", this.newArray);
      }
      setTimeout(() => {
        this.isAllEmpty = true;
        for (let i in this.newArray) {
          if (this.newArray[i].total > 0) {
            this.isAllEmpty = false;
          }
        }
      }, 500);
    },
    // 搜索
    handleSearch() {
      if (this.toggle == "业务流程") {
        this.newArray = [];
        this.list[0].children.map((item) => {
          this.ajaxUtil({
            method: "get",
            url:
              this.$store.state.axiosUrl +
              `/api/home/common/business/page?limit=${this.limit}&page=${this.currentPage}&type2=${item.paramValue}&title=${this.searchResult}`,
          }).then((res) => {
            this.newArray.push({
              data: res.data,
              paramValue: item.paramValue,
              total: res.count,
            });
          });
        });
      } else if (this.toggle == "资料库") {
        this.newArray = [];
        this.list[1].children.map((item) => {
          this.ajaxUtil({
            method: "get",
            url:
              this.$store.state.axiosUrl +
              `/api/home/common/business/page?limit=${this.limit}&page=${this.currentPage}&type2=${item.paramValue}&title=${this.searchResult}`,
          }).then((res) => {
            this.newArray.push({
              data: res.data,
              paramValue: item.paramValue,
              total: res.count,
            });
          });
        });
      }
      setTimeout(() => {
        this.isAllEmpty = true;
        for (let i in this.newArray) {
          if (this.newArray[i].total > 0) {
            this.isAllEmpty = false;
          }
        }
      }, 500);
    },
  },
};
</script>
<style scoped lang="less">
// @import url('~@/assets/css/index.less');
.wrap {
  display: flex;
  flex-direction: column;
  min-width: 12.8em;
  min-height: 110vh;
}
// 公共标题样式
.title {
  color: #2579bf;
  font-size: 16px;
  padding-bottom: 5px;
  border-bottom: 4px solid #2579bf;
  display: inline-block;
}
.swiper_box {
  display: none !important;
}
.specialistContent {
  display: flex;
  flex-direction: column;
  flex: 1;
  // overflow-y: auto;
  width: 100%;
  justify-content: space-between;
  // padding: 0.2em 3em;
  .specialistContent_left {
    font-size: 0.17em;
    color: #333;
    div {
      height: 2.5em;
      text-align: center;
      background-color: #d6f0f6;
      margin-top: 0.08em;
      cursor: pointer;
      font-size: 0.85em;
      width: 240px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .specialistContent_left_title {
      background: radial-gradient(circle, #3cc9e4 0%, #2579bf 100%);
      color: #fff;
      padding: 0.6em;
      //   width: 15em;
      font-size: 1em;
    }
    .bG:hover {
      color: #2579bf;
      background-color: #fff;
    }
    .active {
      color: #2579bf;
      background-color: #fff;
      border-left: 0.5em solid #2579bf;
    }
  }
  .specialistContent_right {
    color: #333;
    margin-left: 2em;
    margin-top: 0.1em;
    font-size: 0.18em;
    flex: 1;
    overflow: hidden;
    // width: 100%;
    .specialistContent_right_title {
      font-size: 0.2em;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 1em;
      border-bottom: 1px solid #e5e5e5;
      div {
        padding-bottom: 1em;
      }
    }
    //   列表
    .listBox {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      li {
        border: 1px solid #eee;
        display: flex;
        flex-direction: column;
        // height: 225px;
        cursor: pointer;
        position: relative;
        width: 22%;
        padding-bottom: 0em;
        margin-top: 20px;
        // height: 13em;

        .listBox-title {
          width: 100%;
          height: 54px;
          line-height: 23px;
          color: #2579bf;
          font-size: 0.8em !important;
          font-weight: 600;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        img {
          height: 122px;
          width: 100%;
        }
        span {
          font-size: 0.28em;
          padding: 5px 10px;
        }
        .company {
          position: absolute;
          top: 95px;
          left: 0;
          width: 100%;
          font-size: 0.8em;
          white-space: nowrap;
          background-color: rgba(0, 0, 0, 0.5);
          color: #fff;
          text-overflow: ellipsis;
          overflow: hidden;
          text-align: center;
        }
        .info {
          padding: 5px 10px;
          padding-bottom: 60px;
          overflow: hidden;
          font-size: 0.15em;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          color: #555;
        }
      }
    }
  }
}
.footer {
  width: 100%;
  // margin-top: 0.2em;
}
.titlePosition {
  font-size: 0.15em;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  color: #666;
}
.box {
  display: flex;
  justify-content: space-between;
  height: 100%;
  overflow: hidden;
}
.addLi {
  border: none !important;
}

.buttonZX {
  text-align: center;
  padding: 7px;
  background: linear-gradient(-90deg, #25ccbd 0%, #30a8da 100%);
  color: #fff;
  margin-top: 10px;
  font-size: 15px;
  cursor: pointer;
  font-weight: 600;
  // position: absolute;
  // bottom: 0;
  // left: 0;
  // width: 100%;
}
/deep/.rightInfo {
  font-size: 1em !important;
  // margin-top: 20px;
  img {
    max-width: 100%;
  }
}
.rightContent {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.serviceContent_item {
  cursor: pointer;
}

// 搜索框
.search {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0.34rem 0 0.34rem 0;
  .search-wrap {
    width: 600px;
    height: 50px;
    line-height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 100px;
    border: 1px solid #2579bf;
    .search-img {
      height: 20px;
      line-height: 50px;
      padding: 0 20px;
      margin-top: 3px;
      cursor: pointer;
    }
    /deep/.el-input {
      font-size: 0.2rem;
    }
  }
  /deep/ .el-input {
    height: 50px;
    line-height: 50px;
    padding: 0 !important;
  }
  /deep/.el-input__inner {
    background-color: rgba(0, 0, 0, 0);
    border: none;
    color: #000;
    height: 50px;
    line-height: 50px;
    margin-top: 2px;
  }
  i {
    font-size: 20px;
    color: #2579bf;
    font-weight: bold;
    display: none !important;
  }
}
// 信息框
.info-box {
  .info-box-container {
    margin-bottom: 0.5rem;
    .info-box-title {
      font-size: 0.2rem;
      font-weight: bold;
      color: #333333;
      margin-bottom: 0.19rem;
    }
    .info-box-content {
      .info-box-content-inner-item {
        font-size: 0.18rem;
        color: #333333;
        margin-bottom: 0.16rem;
      }
    }
  }
}
.link-url {
  color: #333333;
  font-size: 0.18rem;
}
//分页
.pagination {
  margin-top: 0.3rem;
}
/deep/.el-pagination .el-pager .active {
  background: #2579bf !important;
  color: #fff !important;
}
/deep/.el-pagination .el-pager .number {
  color: #333333;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/views/common/index.vue